import { createContext } from 'react';

// Context
const Context = createContext({
  state: {},
  setState: () => {},
});

export default Context;
